class ATCStickyWrapper extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.staticButtons = null;
    this.stickyWrapper = null;
    this.hasScrolledPast = false;
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    this.staticButtons = document.querySelector('.js-pdp-static-buttons');
    this.stickyWrapper = document.querySelector('.atc-sticky-wrapper');

    if (!this.staticButtons || !this.stickyWrapper) {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
            this.hasScrolledPast = true;
            this.stickyWrapper.classList.add('active');
          } else if (entry.isIntersecting && this.hasScrolledPast) {
            this.stickyWrapper.classList.remove('active');
          }
        });
      },
      {
        threshold: 0
      }
    );

    this.observer.observe(this.staticButtons);
  }

  disconnectedCallback() {
    if (this.observer && this.staticButtons) {
      this.observer.unobserve(this.staticButtons);
    }
  }
}

customElements.define('atc-sticky-wrapper', ATCStickyWrapper);
